import { Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { EMRService } from 'app/EMR/EMR.service';
import { AuthService } from 'app/auth/auth.service';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { IPDService } from '../Services/ipdServices.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { MatTableDataSource } from '@angular/material/table';
import { ByIPDWorkup, UserMaster } from '../models/ipdDashboardModel';
import { MatSidenav } from '@angular/material/sidenav';

@Component({
  selector: 'app-pre-anae-question',
  templateUrl: './pre-anae-question.component.html',
  styleUrls: ['./pre-anae-question.component.scss']
})
export class PreAnaeQuestionComponent implements OnInit {
  Prequesdisable: boolean = true;
  dataSourceWorkup = new MatTableDataSource<ByIPDWorkup>();
  dataSource = new MatTableDataSource<UserMaster>();
  AQcheckedyes: boolean = false;
  AQcheckedno: boolean = false;
  AQcheckednone: boolean = false;
  patIpdlist: any = {};
  masterDataList: any=[];
  masterData: any =[];
  prerecordlength: any;
  options: string[] = ["YES", "NO", "NONE"];
  displayedColumnsIpd: string[] = ["headName", "Options", "actualValue"];
  displayedColumns: string[] = ["headName", "isHeader", "defaultValues"];
  @ViewChild(MatSidenav, { static: false }) sidenav: MatSidenav;
  constructor(public dialog: MatDialog, public opdvisitService: OpdVisitService, public authService: AuthService, public emrservice: EMRService, public ipdService: IPDService, public dashboardService: DashboardService, public dialogRef: MatDialogRef<PreAnaeQuestionComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any,) {
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
  this.getByIPdList(this.data.consid);

  }
  closedialog() {
    this.dialogRef.close();
  }
  openMaster() {
    this.Prequesdisable = false;
    this.getAnesthesiaMasterList();
    this.sidenav.toggle();
  }
  getAnesthesiaMasterList() {
    this.ipdService.getAnesthesiaMaster().subscribe((data) => {
    
      this.dataSource.data = data;
      this.masterData = data;
      if (this.prerecordlength == 0) {
        this.masterData = data;
        this.addPreList();
      }
    });
  }
  getvalue(value) {
    this.Prequesdisable = false;
  
    this.dataSourceWorkup.data.map((item) => (item.actualValue = value));
    this.dataSourceWorkup.data = this.dataSourceWorkup.data.map((item) => {
      if (item.pK_TranId === 0) {
        item.isEdit = false;
      } else {
        item.isEdit = true;
        item.fK_ConsID = this.data.consid;
      }
      return item;
    });
    var removenullvalue =this.dataSourceWorkup.data.filter(
      (item) => item.actualValue != null
    );
    const checkYesvalue = removenullvalue.filter(
      (item) => item.actualValue.toLowerCase() == "yes"
    );
    const checkNovalue = removenullvalue.filter(
      (item) => item.actualValue.toLowerCase() == "no"
    );
    const checkNonevalue = removenullvalue.filter(
      (item) => item.actualValue.toLowerCase() == "none"
    );
    if (this.dataSourceWorkup.data.length == checkYesvalue.length) {
      this.AQcheckedyes = true;
      this.AQcheckedno = false;
      this.AQcheckednone = false;
    } else if (this.dataSourceWorkup.data.length == checkNovalue.length) {
      this.AQcheckedyes = false;
      this.AQcheckedno = true;
      this.AQcheckednone = false;
    } else if (this.dataSourceWorkup.data.length == checkNonevalue.length) {
      this.AQcheckedyes = false;
      this.AQcheckedno = false;
      this.AQcheckednone = true;
    } else {
      this.AQcheckedyes = false;
      this.AQcheckedno = false;
      this.AQcheckednone = false;
    }
    this.patIpdlist = this.dataSourceWorkup.data;
  }
  getAQSelectvalue(event, i) {
    this.Prequesdisable = false;
    this.dataSourceWorkup.data[i].isEdit =
      this.dataSourceWorkup.data[i].pK_TranId > 0 ? true : false;
    this.dataSourceWorkup.data[i].actualValue = event.value;
    const checkYesvalue = this.dataSourceWorkup.data.filter(
      (item) => item.actualValue.toLowerCase() == "yes"
    );
    const checkNovalue = this.dataSourceWorkup.data.filter(
      (item) => item.actualValue.toLowerCase() == "no"
    );
    const checkNonevalue = this.dataSourceWorkup.data.filter(
      (item) => item.actualValue.toLowerCase() == "none"
    );
    if (this.dataSourceWorkup.data.length == checkYesvalue.length) {
      this.AQcheckedyes = true;
      this.AQcheckedno = false;
      this.AQcheckednone = false;
    } else if (this.dataSourceWorkup.data.length == checkNovalue.length) {
      this.AQcheckedyes = false;
      this.AQcheckedno = true;
      this.AQcheckednone = false;
    } else if (this.dataSourceWorkup.data.length == checkNonevalue.length) {
      this.AQcheckedyes = false;
      this.AQcheckedno = false;
      this.AQcheckednone = true;
    } else {
      this.AQcheckedyes = false;
      this.AQcheckedno = false;
      this.AQcheckednone = false;
    }
  }
  PreAQcheckstatus(option, i) {
    if (this.dataSourceWorkup.data[i].actualValue != null) {
      return (
        this.dataSourceWorkup.data[i].actualValue.toLowerCase() ==
        option.toLowerCase()
      );
    } else {
      return false;
    }
  }
  selectPreanae(row, i) {
    this.dataSourceWorkup.data[i] = row;
    if (this.dataSourceWorkup.data[i].pK_TranId === 0) {
      this.dataSourceWorkup.data[i].isEdit = false;
      this.patIpdlist = this.masterDataList;
    } else {
      this.dataSourceWorkup.data[i].isEdit = true;
      this.dataSourceWorkup.data[i].fK_ConsID = this.data.consid;
      this.patIpdlist = this.dataSourceWorkup.data;
    }
    this.dataSourceWorkup.data = this.dataSourceWorkup.data.map((item) => {
      if (item.pK_TranId === 0) {
        item.isEdit = false;
      } else {
        item.isEdit = true;
        item.fK_ConsID = this.data.consid;
      }
      return item;
    });
  }
  addPreList() {
    this.masterDataList = [];
    this.masterData.forEach((element) => {
      this.masterDataList.push({
        actualValue: element.defaultValues,
        fK_ConsID : this.data.consid,
        headName: element.headName,
        isEdit: false,
        isHeader: element.isHeader,
        isHidden: element.isHidden,
        pK_SynchId: element.pK_SynchId,
        pK_TranId: 0,
      });
    });
    this.dataSourceWorkup.data = this.masterDataList;
    this.patIpdlist = this.masterDataList;
  }

  savePatIpd(event) {
    const button =
      event.srcElement.disabled === undefined
        ? event.srcElement.parentElement
        : event.srcElement;
    button.setAttribute("disabled", true);
   
    let preList = Object.keys(this.patIpdlist).map(
      (key) => this.patIpdlist[key]
    );
    let payLoadList = {
      AnesthesiaQuestionsDetailDto: preList,
    };
    this.ipdService.addAnesthesiaIpd(payLoadList).subscribe((data) => {
      if (data.statusCode == 1) {
        this.Prequesdisable = true;
        this.getByIPdList(this.data.consid);
        this.dashboardService.openSnackBar(
          "Updated The Record Successfully",
          "OK"
        );
      }
    });
  }
  addRow() {
    const newRow: UserMaster = {
      pK_TranId: 0,
      headName: "",
      defaultValues: "",
      isHeader: false,
      isActive: true,
      pK_SynchId: null,
      isEdit: false,
      isHidden: false,
      Uid: this.dataSource.data.length + 1,
    };
    this.dataSource.data = [newRow, ...this.dataSource.data];
  }
  preaneQuestion: boolean = false;
  getByIPdList(id) {
    this.prerecordlength = "";
    this.ipdService.getByIpdId(0,id).subscribe((data) => {
     
      if (data.length > 0) {
        var removenullvalue =data.filter(
          (item) => item.actualValue != null
        );
        const checkYesvalue = removenullvalue.filter(
          (item) => item.actualValue.toLowerCase() == "yes"
        );
        const checkNovalue = removenullvalue.filter(
          (item) => item.actualValue.toLowerCase() == "no"
        );
        const checkNonevalue = removenullvalue.filter(
          (item) => item.actualValue.toLowerCase() == "none"
        );
        if (data.length == checkYesvalue.length) {
          this.AQcheckedyes = true;
          this.AQcheckedno = false;
          this.AQcheckednone = false;
        } else if (data.length == checkNovalue.length) {
          this.AQcheckedyes = false;
          this.AQcheckedno = true;
          this.AQcheckednone = false;
        } else if (data.length == checkNonevalue.length) {
          this.AQcheckedyes = false;
          this.AQcheckedno = false;
          this.AQcheckednone = true;
        } else {
          this.AQcheckedyes = false;
          this.AQcheckedno = false;
          this.AQcheckednone = false;
        }
        this.preaneQuestion = true;
        this.dataSourceWorkup.data = data;
      } else {
        this.preaneQuestion = false;
        this.prerecordlength = data.length;
        this.getAnesthesiaMasterList()
       
      }
    });
  }
  selectedrow: any;
  modifyList: any = {};
  selectRow(row) {
    this.selectedrow = row;

    if (this.selectedrow.pK_TranId === 0) {
      this.selectedrow.isEdit = false;
      this.modifyList[row.Uid] = row;
    } else {
      this.selectedrow.isEdit = true;
      this.modifyList[this.selectedrow.pK_TranId] = this.selectedrow;
    }
  }
  cancelbtn() {
    this.sidenav.toggle();
    this.modifyList = {};
    this.getAnesthesiaMasterList();
  }
  saveRecord() {
    debugger
    let preQList = [];
    let arrayList = Object.keys(this.modifyList).map(
      (key) => this.modifyList[key]
    );
    let payLoad = {
      AnesthesiaQuestionsDto: arrayList,
    };
    arrayList
      .filter((item) => item.pK_TranId == 0)
      .forEach((element) => {
        preQList.push({
          actualValue: element.defaultValues,
          fK_ConsID : this.data.consid,
          headName: element.headName,
          isEdit: element.isEdit,
          isHeader: element.isHeader,
          isHidden: element.isHidden,
          pK_SynchId: element.pK_SynchId,
          pK_TranId: 0,
        });
      });
    let prePayLoadList = {
      AnesthesiaQuestionsDetailDto: preQList,
    };
    if (preQList.length > 0) {
      this.ipdService.addAnesthesiaIpd(prePayLoadList).subscribe((data) => {
        if (this.prerecordlength == 0) {
          this.getAnesthesiaMasterList();
        } else {
          this.getByIPdList(this.data.consid);
        }
      });
    }

    this.ipdService.addAnesthesiaMaster(payLoad).subscribe((data) => {
      if (data.statusCode == 1) {
        this.dashboardService.openSnackBar(
          "Created/Updated The Record Successfully",
          "OK"
        );
      }
      this.sidenav.toggle();
      this.modifyList = {};
    });
  }
}
